module.exports = __webpack_public_path__ + "static/media/sf-test-10.a9e0cd43.mp3";